import { Templates, useTemplate } from "@/util-react/template";
import { LogisticAndDeliveryDesktopBlackAndBlue } from "./templates/logistic.black-and-blue";

const templates: Record<Templates, React.ComponentType | null> = {
  [Templates.DEFAULT]: null,
  [Templates.BLACK_AND_BLUE]: LogisticAndDeliveryDesktopBlackAndBlue,
};

export const LogisticAndDeliveryDesktop = () => {
  const template = useTemplate();

  const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

  return TemplatedComponent ? <TemplatedComponent /> : null;
};
